import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898722601';

export function cart_message(type, message, data) {
    if (message == 'cart.merged') {
        return;
    }
    messages.push(window.__(message, data), type);
}
